import axios from "axios";

function getHeaders() {
  return {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  };
}

export const deleteCustomer = async (id) => {
  try {
    const response = await axios.delete(
      `${process.env.REACT_APP_BASE_URL}/customer/customer-detail/${id}/`,
      getHeaders()
    );
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const getCustomer = async (id) => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/customer/customer-detail/${id}/`,
      getHeaders()
    );
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const updateCustomer = async (id, data) => {
  try {
    const response = await axios.patch(
      `${process.env.REACT_APP_BASE_URL}/customer/customer-detail/${id}/`,
      data,
      getHeaders()
    );
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};

export const getCustomers = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/customer/customer-detail/`,
      getHeaders()
    );
    return response;
  } catch (error) {
    if (error.response) {
      console.error("Backend Error:", error.response.data);
    } else {
      console.error("Network Error:", error);
    }
    throw error;
  }
};
